export const generateJurisprudenceTitle = (
    jurisdiction: string,
    juridictionNom: string,
    number: string,
    decisionDate: string,
    chamber?: string
) => {
    const chamberPart = chamber ? ` - ${chamber}` : '';
    // Priorité : nom propre depuis la collection juridictions, fallback sur le champ jurisdiction texte.
    const displayName = juridictionNom || jurisdiction || 'Juridiction inconnue';

    return `${decisionDate || 'Date inconnue'} - ${displayName}${chamberPart} ${number ? `n° ${number}` : ''}`.trim();
};
